// Button atom component
export const Button = ({
  children,
  onClick,
  className = "",
  variant = "primary",
  ...props
}) => {
  const baseStyles =
    "px-6 py-3 rounded-full font-semibold tracking-tight transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-terracotta-400 disabled:opacity-50 disabled:cursor-not-allowed";

  const variants = {
    primary:
      "bg-terracotta-600 text-white shadow-soft hover:bg-terracotta-700 hover:shadow-lift",
    secondary:
      "bg-cream text-terracotta-800 border border-terracotta-200 hover:bg-terracotta-100",
    cta: "bg-ink-teal text-white shadow-soft hover:shadow-lift hover:-translate-y-0.5",
  };

  const finalClassName = `${baseStyles} ${variants[variant]} ${className}`;

  return (
    <button className={finalClassName} onClick={onClick} {...props}>
      {children}
    </button>
  );
};
